// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_WB3","cls2":"LettersModal-cls2_9d1 LettersModal-cls1_WB3"};